import CheckIcon from "@mui/icons-material/Check";
import React from "react";

import useResponsive from "src/hooks/useResponsive";

const CheckList = ({ items, horizontal = false }: { items: (string | React.ReactElement)[]; horizontal?: boolean }) => {
  const isMdUp = useResponsive("up", "md");
  if (horizontal) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: isMdUp ? "row" : "column",
          justifyContent: "space-evenly",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        {items.map((item, idx) => (
          <div key={idx} style={{ display: "flex", alignItems: "center" }}>
            <CheckIcon style={{ color: "#ff6600", marginRight: "8px", fontSize: "20px" }} />
            <span>{item}</span>
          </div>
        ))}
      </div>
    );
  }
  return (
    <ul style={{ paddingLeft: 0 }}>
      {items.map((item, idx) => (
        <li key={idx} style={{ marginBottom: "12px", display: "flex", alignItems: "flex-start" }}>
          <CheckIcon style={{ color: "#ff6600", marginRight: "8px", fontSize: "20px" }} />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export { CheckList };
